import { create } from "zustand";

interface MapStageState {
  isCompleted: boolean;
  setCompleted: (isInvited: boolean) => void;
}

export const useMapStageCompletionStore = create<MapStageState>((set) => ({
  isCompleted: false,
  setCompleted: (isCompleted) => set({ isCompleted }),
}));
